import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import GeneralVoucherCodeReportCard from "../../components/report/GeneralVoucherCodeReportCard";
import UniqueVoucherCodeReportCard from "../../components/report/VoucherCodeReportCard";

const VoucherCodeReport = ({ token, admin }) => {
    const history = useHistory();
    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!admin || !admin.voucher_code_report) {
            history.push("/admin/dashboard");
        }
    }, []);

    const handleToggle = () => {
        setToggled(!toggled);
    };

    return (
        <div className="admin-page-container">
            <Sidebar toggled={toggled} setToggled={handleToggle} />
            <div className="admin-page">
                <Topbar handleToggle={handleToggle} />
                <div className="admin-content">
                    <GeneralVoucherCodeReportCard 
                        role="operator"
                        token={token}
                    />

                    <UniqueVoucherCodeReportCard
                        role="operator"
                        token={token}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    admin: state.admin.admin,
    token: state.admin.token,
});

export default connect(mapStateToProps)(VoucherCodeReport);